var _excluded = ["email"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import fetchCheckout, { fetchShop } from "./async";
import { getQuery, setCookie } from "../util/dom";
import { stokpress } from "../util/helper";
import { inputError, removeUrlParam } from "../util/string";
import { deepClone, deepCompare } from "../util/object";
import store from "./store";
import { paymentMethodsMap } from "../config";
import { renderMessage } from "../partials/top/message-bar";
import { scrollToElement } from "../components/scroll";
import { handleGeoBasedRedirect as handlePfasGeoBasedRedirect } from "../components/pfas";
export var setCountry = function setCountry() {
  console.log("setCountry");
  var query = getQuery();
  if (query.hasOwnProperty("country") && query.country && isValidCountry(query.country.toUpperCase())) {
    var queryCountry = query.country;
    var country = query.country.toUpperCase();
    if (!store.getState().store.country || store.getState().store.country && store.getState().store.country != country) {
      console.log("set country from query:", country);
      changeCountry(country).then(function () {
        console.log("country changed");
        $(window).trigger("store.setCountry", store.getState());
      });
    } else {
      $(window).trigger("store.setCountry", store.getState());
    }
    var newParam = removeUrlParam(window.location.search, "country", queryCountry);
    window.history.pushState("", "", window.location.pathname + newParam);
  } else if (!store.getState().store.country) {
    fetchCheckout("/countries/auto").then(function (data) {
      var country_code = "NO";
      var token = "";
      if (_typeof(data) === "object" && typeof data.country != "undefined") {
        country_code = data.country.country;
        token = data.token;
      } else {
        var nav_lang = navigator.language.toLocaleLowerCase();
        switch (nav_lang) {
          case "nn":
          case "no":
          case "nb":
            country_code = "NO";
            break;
          case "ja":
            country_code = "JP";
            break;
          default:
            country_code = "US";
        }
      }
      console.log("set country");
      var store_countries = window.sitewide.countries;
      store.dispatch({
        type: "UPDATE_COUNTRIES",
        store_countries: store_countries
      });
      var country = store_countries[country_code];
      if (token) {
        country.token = token;
      }
      store.dispatch({
        type: "UPDATE_ESC_STORE",
        country: country
      });
      updateProductCache(true);
      setDefaultPaymentMethod(true);
      handlePfasGeoBasedRedirect(country.country || '');
      $(window).trigger("store.setCountry", store.getState());
      $(window).trigger("store.changeCountry", store.getState());
    });
  } else {
    setDefaultPaymentMethod(false);
    $(window).trigger("store.setCountry", store.getState());
  }
};
export var updateGlobalECountry = function updateGlobalECountry() {
  var forceReload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var _store$getState = store.getState(),
    escStore = _store$getState.store;

  // Global E geo IP data
  if (escStore && escStore.country) {
    var interval = setInterval(function () {
      if (typeof GEM_Components === 'undefined') {
        return;
      }
      clearInterval(interval);
      if (forceReload) {
        GEM_Components.ExternalMethodsComponent.SetUserLocalization({
          "CountryCode": escStore.country,
          "CurrencyCode": escStore.currency
        });
      } else {
        GEM_Components.ExternalMethodsComponent.ChangeLocalizeSettings(escStore.country, escStore.currency);
      }
    }, 1000);
  }
};
export var setDefaultPaymentMethod = function setDefaultPaymentMethod() {
  var forceInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _store$getState$store = store.getState().store,
    country = _store$getState$store.country,
    token = _store$getState$store.token;
  var _store$getState2 = store.getState(),
    selection = _store$getState2.selection,
    defaultPaymentInitiated = _store$getState2.defaultPaymentInitiated;

  // Halt process if default payment already initiated
  if (defaultPaymentInitiated && forceInit === false) return;
  if (selection && Object.keys(selection).length === 0 && selection.constructor === Object) {
    updateSelection(token);
  }
  var _store$getState$selec = store.getState().selection,
    paymentMethod = _store$getState$selec.paymentMethod,
    paymentMethods = _store$getState$selec.paymentMethods;
  var defaultPaymentMethod = window.sitewide.defaultPaymentMethod || {};

  /* Default Payment method is not set in sitewide or
   * default payment method is set in the current country
   */
  if (!defaultPaymentMethod || !defaultPaymentMethod[country]) return; // Default Payment method is not set in sitewide

  var method = defaultPaymentMethod[country];
  if (!paymentMethods) return;
  var availablePaymentMethods = paymentMethods.map(function (item) {
    return item.paymentMethod;
  });
  if (method === paymentMethod) return; // default payment method is already set
  if ($.inArray(method, availablePaymentMethods) === -1) return; // default payment method is not available in the country

  store.dispatch({
    type: "SET_DEFAULT_PAYMENT_METHOD"
  });
  if ($("#js-paymentChoices input[value=".concat(method, "]")).length) {
    $("#js-paymentChoices input[value=".concat(method, "]")).trigger('click');
  } else {
    changePaymentMethod(method).then(function (data) {
      // Do nothing
    });
  }
};
export var isValidCountry = function isValidCountry(country) {
  return window.sitewide.countries && window.sitewide.countries[country] ? true : false;
};
export var getPaymentInfoItem = function getPaymentInfoItem(key) {
  return key && store.getState().hasOwnProperty("".concat(key)) ? store.getState()[key] : null;
};

/*
 * WP FETCHES
 */
export var updateProductCache = function updateProductCache(forceReload) {
  /* If last update was more than 10 mins ago update product cache */
  if ((!store.getState().productCache.updated || store.getState().productCache.updated + 6e5 < Date.now() || forceReload) && store.getState().store.pricelist) {
    fetchShop("countries").then(function (countries) {
      store.dispatch({
        type: "UPDATE_COUNTRIES",
        countries: countries
      });
    });
    fetchShop("geCountries").then(function (geCountries) {
      store.dispatch({
        type: "UPDATE_GE_COUNTRIES",
        geCountries: geCountries
      });
    });
    return fetchShop("product_cache/".concat(store.getState().store.market, "/").concat(store.getState().store.pricelist)).then(function (cache) {
      store.dispatch({
        type: "UPDATE_PRODUCT_CACHE",
        cache: cache
      });
      store.dispatch({
        type: "UPDATE_CATEGORY_CACHE",
        cache: cache
      });
      store.dispatch({
        type: "UPDATE_BUNDLES_CACHE",
        cache: cache
      });
      store.dispatch({
        type: "UPDATE_PRICELIST",
        cache: cache
      });
      $(window).trigger("store.productCache", store.getState());
    });
  }
  if (store.getState().productCache.items) {
    $(window).trigger("store.productCache", store.getState());
  }
  return false;
};

// export const getQuickShop = productID => {
// 	if ( store.getState().quickShop && store.getState().quickShop[productID] ) {
// 		return new Promise( resolve =>
// 			resolve( store.getState().quickShop[productID] )
// 		);
// 	}

// 	return fetchShop( `quick_shop/${productID}` ).then( product =>
// 		store.dispatch( { type: "QUICK_SHOP", product, productID } )
// 	);
// };

export var getProductItem = function getProductItem(productID) {
  if (store.getState().productListItems && store.getState().productListItems[productID]) {
    return new Promise(function (resolve) {
      return resolve(store.getState().productListItems[productID]);
    });
  }
  return fetchShop("change_product/".concat(productID)).then(function (product) {
    return store.dispatch({
      type: "UPDATE_PRODUCT_LIST_ITEM",
      product: product,
      productID: productID
    });
  });
};

/*
 * JS STORE UPDATES
 */

// export const addToFavourites = product =>
// 	new Promise( resolve =>
// 		resolve( store.dispatch( { type: "UPDATE_FAVOURITES", product } ) )
// 	);

export var productListDensity = function productListDensity() {
  return new Promise(function (resolve) {
    return resolve(store.dispatch({
      type: "PRODUCT_LIST_DENSITY"
    }));
  });
};

/*
 * CENTRA ACCOUNT
 */

export var toggleLogin = function toggleLogin() {
  return store.dispatch({
    type: "TOGGLE_LOGIN"
  });
};
export var entryState = function entryState(state) {
  return store.dispatch({
    type: "TOGGLE_ACCOUNT_ENTRY",
    state: state
  });
};
export var forgot = function forgot(token, _ref) {
  var email = _ref.email;
  return fetchCheckout("/password-reset-email/".concat(email), token, {
    linkUri: "".concat(window.sitewide.prefix).concat(window.sitewide.loginPage.split("/").filter(function (uri) {
      return !!uri;
    }).slice(-1)[0], "/").replace(/^\/+/, "")
  }, "POST").then(function (data) {
    return data.hasOwnProperty("errors") ? new Promise(function (resolve, reject) {
      return reject();
    }) : data;
  }).then(function () {
    return store.dispatch({
      type: "ACCOUNT_FORGOT_SENT"
    });
  }).catch(function () {
    return store.dispatch({
      type: "ACCOUNT_FORGOT_FAILED",
      hasError: true
    });
  });
};
export var resetPassword = function resetPassword(token, args) {
  return fetchCheckout("/password-reset", token, args, "POST").then(function (accountData) {
    return store.dispatch({
      type: "UPDATE_ACCOUNT",
      data: accountData
    });
  }).catch(function () {
    return store.dispatch({
      type: "ACCOUNT_ENTRY_FAILED",
      hasError: true
    });
  });
};
export var login = function login(token, _ref2) {
  var email = _ref2.email,
    args = _objectWithoutProperties(_ref2, _excluded);
  return fetchCheckout("/login/".concat(email), token, args, "POST").then(function (accountData) {
    if (accountData.errors && accountData.errors.password) return store.dispatch({
      type: "SELECTION_ERROR_PASSWORD",
      hasError: true
    });
    return store.dispatch({
      type: "UPDATE_ACCOUNT",
      data: accountData
    });
  }).catch(function () {
    return store.dispatch({
      type: "ACCOUNT_ENTRY_FAILED",
      hasError: true
    });
  });
};
export var register = function register(token, args) {
  return fetchCheckout("/register", token, args, "POST").then(function (accountData) {
    if (accountData.errors) {
      if (accountData.errors.email) return store.dispatch({
        type: "SELECTION_ERROR_REGISTERED",
        hasError: true
      });
      return store.dispatch({
        type: "ACCOUNT_ENTRY_FAILED",
        hasError: true
      });
    }
    return store.dispatch({
      type: "UPDATE_ACCOUNT",
      data: accountData
    });
  }).catch(function () {
    return store.dispatch({
      type: "ACCOUNT_ENTRY_FAILED",
      hasError: true
    });
  });
};
export var entryAccount = function entryAccount(checkoutEntry) {
  var _store$getState$store2 = store.getState().store,
    token = _store$getState$store2.token,
    country = _store$getState$store2.country;
  var _store$getState3 = store.getState(),
    accountEntry = _store$getState3.accountEntry,
    payment = _store$getState3.payment;
  var _payment$address = payment.address,
    email = _payment$address.email,
    emailRepeat = _payment$address.emailRepeat,
    firstName = _payment$address.firstName,
    lastName = _payment$address.lastName,
    password = _payment$address.password,
    passwordRepeat = _payment$address.passwordRepeat,
    newsletter = _payment$address.newsletter;
  var errors = {
    address: {}
  };
  if (["register", "forgot", "login"].indexOf(accountEntry) !== -1 && inputError(email, "email")) {
    errors.address.email = 1;
  }
  if (["register", "reset", "login"].indexOf(accountEntry) !== -1 && inputError(password, "password")) {
    errors.address.password = 1;
  }
  if (["register", "reset"].indexOf(accountEntry) !== -1 && password !== passwordRepeat) {
    errors.address.passwordRepeat = 1;
  }
  if (["register"].indexOf(accountEntry) !== -1) {
    if (email !== emailRepeat) errors.address.emailRepeat = 1;
    if (inputError(firstName)) errors.address.firstName = 1;
    if (inputError(lastName)) errors.address.lastName = 1;
    if (!payment.termsAndConditions) errors.termsAndConditions = 1;
  }
  if (!deepCompare(errors, {
    address: {}
  })) {
    store.dispatch({
      type: "FORM_ERRORS",
      errors: errors
    });
    return new Promise(function (resolve, reject) {
      return reject();
    });
  }

  // Route to correct connect
  if (accountEntry === "reset") {
    return resetPassword(token, _objectSpread({
      newPassword: password
    }, getQuery()));
  }
  if (accountEntry === "forgot") {
    return forgot(token, {
      email: email
    });
  }
  if (accountEntry === "login" || checkoutEntry === "login") {
    return login(token, {
      email: email,
      password: password
    });
  }
  return register(token, {
    email: email,
    password: password,
    firstName: firstName,
    lastName: lastName,
    newsletter: newsletter,
    country: country
  });
};
export var accountOrders = function accountOrders() {
  var token = store.getState().store.token;
  var _store$getState$accou = store.getState().account.orders,
    orders = _store$getState$accou === void 0 ? [] : _store$getState$accou;
  return fetchCheckout("/orders", token, {
    size: 3,
    from: orders.length
  }, "POST").then(function (data) {
    store.dispatch({
      type: "UPDATE_ACCOUNT",
      data: data
    });
    return store.dispatch({
      type: "ACCOUNT_ORDERS",
      data: data
    });
  }).catch(function (err) {
    return store.dispatch({
      type: "ACCOUNT_ORDERS_FAILED",
      err: err
    });
  });
};
export var updateAccountAddress = function updateAccountAddress() {
  var token = store.getState().store.token;
  var _store$getState4 = store.getState(),
    countries = _store$getState4.countries,
    payment = _store$getState4.payment;
  var args = {};
  var errors = {
    address: {}
  };
  var requiredFields = ["firstName", "lastName", "address1", "zipCode", "city", "phoneNumber", "country"];
  Object.keys(payment.address).forEach(function (input) {
    var value = payment.address[input];
    var checkStates = input === "state" && countries[payment.address.country].states;
    if (checkStates && !checkStates[value]) errors.address.state = 1;
    if (requiredFields.indexOf(input) !== -1 && inputError(value, input)) errors.address[input] = 1;
    if (input.indexOf("password") === -1 && input.indexOf("email") === -1) {
      args[input] = value;
    }
  });
  if (!deepCompare(errors, {
    address: {}
  })) {
    store.dispatch({
      type: "FORM_ERRORS",
      errors: errors
    });
    return new Promise(function (resolve, reject) {
      return reject();
    });
  }
  return fetchCheckout("/customer/update", token, args, "PUT").then(function (data) {
    return store.dispatch({
      type: "UPDATE_ACCOUNT",
      data: data
    });
  }).catch(function () {
    return store.dispatch({
      type: "UPDATE_ACCOUNT_FAILED"
    });
  });
};
export var updateAccountEmail = function updateAccountEmail() {
  var token = store.getState().store.token;
  var _store$getState$payme = store.getState().payment.address,
    emailNew = _store$getState$payme.emailNew,
    emailNewRepeat = _store$getState$payme.emailNewRepeat;
  var errors = {
    address: {}
  };
  if (inputError(emailNew, "email")) errors.address.emailNew = 1;
  if (emailNew !== emailNewRepeat) errors.address.emailNewRepeat = 1;
  if (!deepCompare(errors, {
    address: {}
  })) {
    store.dispatch({
      type: "FORM_ERRORS",
      errors: errors
    });
    return new Promise(function (resolve, reject) {
      return reject();
    });
  }
  return fetchCheckout("/email", token, {
    newEmail: emailNew
  }, "PUT").then(function (data) {
    if (data.errors && data.errors.newEmail) return store.dispatch({
      type: "SELECTION_ERROR_REGISTERED",
      hasError: true
    });
    return store.dispatch({
      type: "UPDATE_ACCOUNT",
      data: data
    });
  }).catch(function () {
    return store.dispatch({
      type: "UPDATE_ACCOUNT_FAILED"
    });
  });
};
export var updateAccountPassword = function updateAccountPassword() {
  var token = store.getState().store.token;
  var _store$getState$payme2 = store.getState().payment.address,
    passwordNew = _store$getState$payme2.passwordNew,
    passwordNewRepeat = _store$getState$payme2.passwordNewRepeat,
    passwordOld = _store$getState$payme2.passwordOld;
  var errors = {
    address: {}
  };
  if (inputError(passwordOld, "password")) errors.address.passwordOld = 1;
  if (inputError(passwordNew, "password")) errors.address.passwordNew = 1;
  if (passwordNew !== passwordNewRepeat) errors.address.passwordNewRepeat = 1;
  if (!deepCompare(errors, {
    address: {}
  })) {
    store.dispatch({
      type: "FORM_ERRORS",
      errors: errors
    });
    return new Promise(function (resolve, reject) {
      return reject();
    });
  }
  return fetchCheckout("/password", token, {
    password: passwordOld,
    newPassword: passwordNew
  }, "PUT").then(function (data) {
    if (data.errors && data.errors.password) return store.dispatch({
      type: "SELECTION_ERROR_PASSWORD",
      hasError: true
    });
    return store.dispatch({
      type: "UPDATE_ACCOUNT",
      data: data
    });
  }).catch(function () {
    return store.dispatch({
      type: "UPDATE_ACCOUNT_FAILED"
    });
  });
};
export var updateAccountConsents = function updateAccountConsents() {
  var token = store.getState().store.token;
  var _store$getState$payme3 = store.getState().payment.address,
    newsletter = _store$getState$payme3.newsletter,
    firstName = _store$getState$payme3.firstName,
    lastName = _store$getState$payme3.lastName;

  /*
  Centra requires sending in firstName and lastName for some reason.
  This can cause a small issue where the customer inadvertently updates
  their firstName and lastName in another form due to pulling the data
  from the store instead of the form.
  A small risk but no large consequences of doing so.
  */
  return fetchCheckout("/customer/update", token, {
    newsletter: newsletter,
    firstName: firstName,
    lastName: lastName
  }, "PUT").then(function (data) {
    return store.dispatch({
      type: "UPDATE_ACCOUNT",
      data: data
    });
  }).catch(function () {
    return store.dispatch({
      type: "UPDATE_ACCOUNT_FAILED"
    });
  });
};
export var logoutAccount = function logoutAccount() {
  var token = store.getState().store.token;
  return fetchCheckout("/logout", token, {}, "POST").then(function () {
    return store.dispatch({
      type: "ACCOUNT_LOGOUT"
    });
  }).catch(function () {
    return store.dispatch({
      type: "ACCOUNT_LOGOUT_FAILED"
    });
  });
};

/*
 * CENTRA ECOMMERCE
 */

export var removeInvalidPaymentFields = function removeInvalidPaymentFields(paymentData, countries, country, useShippingAddress) {
  var keepPassword = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var returnData = deepClone(paymentData);

  // Temporary state
  delete returnData.createAccount;
  delete returnData.loggedIn;
  delete returnData.voyadoId;
  delete returnData.dutyConsent;

  // Account fields
  delete returnData.address.emailOld;
  delete returnData.address.emailNew;
  delete returnData.address.emailRepeat;
  delete returnData.address.emailNewRepeat;
  if (!keepPassword) delete returnData.address.password;
  delete returnData.address.passwordNew;
  delete returnData.address.passwordRepeat;
  delete returnData.address.passwordNewRepeat;
  delete returnData.address.passwordOld;

  // Add required fields
  if (useShippingAddress) {
    returnData.shippingAddress.country = country;
  } else {
    returnData.address = paymentData.shippingAddress;
    delete returnData.shippingAddress;
  }
  returnData.address.country = returnData.address.country || country;

  // Check that state is correct and applicable else remove.
  if (!(returnData.address.state && returnData.address.country && countries[returnData.address.country].states && countries[returnData.address.country].states[returnData.address.state])) delete returnData.address.state;
  // Check that state is correct and applicable else remove.
  if (returnData.shippingAddress && !(returnData.shippingAddress.state && returnData.shippingAddress.country && countries[returnData.shippingAddress.country].states && countries[returnData.shippingAddress.country].states[returnData.shippingAddress.state])) delete returnData.shippingAddress.state;
  returnData.paymentFailedPage = window.sitewide.paymentFailedPage;
  returnData.paymentReturnPage = window.sitewide.paymentReturnPage;
  return returnData;
};
export var updateSelection = function updateSelection(token) {
  if (token == "") {
    var country = store.getState().store.country;
    changeCountry(country);
    console.log("resetup country");
    return false;
  }
  return fetchCheckout("/selection", token, [], "GET").then(function (data) {
    if (data.errors) return store.dispatch({
      type: "UPDATE_SELECTION_ERROR"
    });
    return store.dispatch({
      type: "UPDATE_SELECTION",
      data: data
    });
  }).catch(function (err) {
    return console.log("DEBUG: err", err);
  });
};
export var toggleGiftWrap = function toggleGiftWrap() {
  return store.dispatch({
    type: "TOGGLE_GIFT_WRAP"
  });
};
export var subscribeToNewsletter = function subscribeToNewsletter(email, item, gender, country, language) {
  var _store$getState$store3 = store.getState().store,
    token = _store$getState$store3.token,
    escCountry = _store$getState$store3.country;
  var payload = {};
  if (item !== undefined) {
    payload.item = item;
  }
  if (gender !== undefined) {
    payload.gender = gender;
  }
  if (country !== undefined) {
    payload.country = country;
  } else if (escCountry !== undefined) {
    payload.country = escCountry;
  }
  if (language !== undefined) {
    payload.language = language;
  }
  return fetchCheckout("/newsletter-subscription/".concat(email), token, payload, "POST").then(function () {
    return store.dispatch({
      type: "SUBSCRIBED",
      email: email
    });
  }).catch(function (err) {
    return console.log("DEBUG: error when subscribing to newsletter ", err);
  });
};
export var addToBag = function addToBag(item) {
  var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var _store$getState$store4 = store.getState().store,
    token = _store$getState$store4.token,
    country = _store$getState$store4.country;
  var _store$getState5 = store.getState(),
    selection = _store$getState5.selection;

  // Check if there's no selection exists
  if (!country) {
    setCountry();
  } else if (Object.keys(selection).length === 0 || !token) {
    updateSelection(token || "");
  }
  return fetchCheckout("/items/".concat(item, "/quantity/").concat(quantity), token, [], "POST").then(function (data) {
    if (data.errors) return store.dispatch({
      type: "ADD_TO_BAG_ERROR"
    });
    return store.dispatch({
      type: "UPDATE_SELECTION",
      data: data
    });
  }).catch(function (err) {
    return console.log("DEBUG: err", err);
  });
};
export var changeQuantity = function changeQuantity(line, quantity) {
  var token = store.getState().store.token;
  var _store$getState6 = store.getState(),
    _store$getState6$sele = _store$getState6.selection,
    selection = _store$getState6$sele === void 0 ? {} : _store$getState6$sele;

  // Before removing an item, check if there's another item with similar line. If it exists, remove only 1 instead all of it.
  if (quantity === 0) {
    var similarItemCount = selection.items.filter(function (item) {
      return item.line === line;
    }).length;
    quantity = similarItemCount <= 1 ? 0 : similarItemCount - 1;
  }
  return fetchCheckout("/lines/".concat(line, "/quantity/").concat(quantity), token, [], "PUT").then(function (data) {
    store.dispatch({
      type: "UPDATE_SELECTION",
      data: data
    });
    return data;
  }).catch(function (err) {
    return console.log("DEBUG: err", err);
  });
};
export var bulkChangeQuantity = function bulkChangeQuantity(lines) {
  var token = store.getState().store.token;
  return fetchCheckout("/items", token, {
    lines: lines
  }, "PUT").then(function (data) {
    return store.dispatch({
      type: "UPDATE_SELECTION",
      data: data
    });
  }).catch(function (err) {
    return console.log("DEBUG: err", err);
  });
};
export var changeSize = function changeSize(product, line, quantity, newItem) {
  var token = store.getState().store.token;

  // Remove previous product
  return fetchCheckout("/lines/".concat(line, "/quantity/0"), token, [], "PUT").then(function () {
    return fetchCheckout("/items/".concat(newItem, "/quantity/").concat(quantity), token, [], "POST");
  }).then(function (data) {
    return store.dispatch({
      type: "UPDATE_SELECTION",
      data: data
    });
  }).catch(function (err) {
    return console.log("DEBUG: err", err);
  });
};
export var changeCountry = function changeCountry(country) {
  var _$;
  var _store$getState7 = store.getState(),
    countries = _store$getState7.countries;
  if (!countries[country] || !countries[country].shipTo) return new Promise(function (_, reject) {
    return reject();
  });
  var token = store.getState().store.token;
  var storeCountry = countries[country];
  storeCountry.token = token;
  resetCheckoutFields(country, "");
  store.dispatch({
    type: "UPDATE_ESC_STORE",
    country: storeCountry
  });
  (_$ = $(".js-loader")) === null || _$ === void 0 ? void 0 : _$.removeClass("d-none");
  return fetchCheckout("/countries/".concat(country), token, [], "PUT").then(function (data) {
    store.dispatch({
      type: "UPDATE_SELECTION",
      data: data
    });
    return updateProductCache(true).then(function () {
      var _$2;
      renderMessage();
      setDefaultPaymentMethod(true);
      $(window).trigger("store.changeCountry", store.getState());
      (_$2 = $(".js-loader")) === null || _$2 === void 0 ? void 0 : _$2.addClass("d-none");
      return data;
    }).catch(function (err) {
      return console.log("DEBUG: err", err);
    });
  }).catch(function (err) {
    return console.log("DEBUG: err", err);
  });
};
export var updateLanguage = function updateLanguage(language) {
  var _store$getState8 = store.getState(),
    countries = _store$getState8.countries;
  var country = store.getState().store.country;

  // Dummy function to enable thens if no sign in required.
  if (!countries[country] || !countries[country].language) return new Promise(function (resolve) {
    return resolve();
  });
  var token = store.getState().store.token;
  if (!language) language = countries[country].language;
  var storeCountry = countries[country];
  storeCountry.language = language;
  storeCountry.token = token;
  store.dispatch({
    type: "UPDATE_ESC_STORE",
    country: storeCountry
  });
  return fetchCheckout("/languages/".concat(language), token, [], "PUT").then(function (data) {
    store.dispatch({
      type: "UPDATE_SELECTION",
      data: data
    });
    updateProductCache(true);
  }).catch(function (err) {
    return console.log("DEBUG: err", err);
  });
};
export var changePaymentMethod = function changePaymentMethod(method) {
  var token = store.getState().store.token;
  return fetchCheckout("/payment-methods/".concat(method), token, [], "PUT").then(function (data) {
    return store.dispatch({
      type: "UPDATE_SELECTION",
      data: data
    });
  }).catch(function (err) {
    return console.log("DEBUG: err", err);
  });
};
export var changeShippingMethod = function changeShippingMethod(method) {
  var token = store.getState().store.token;
  return fetchCheckout("/shipping-methods/".concat(method), token, [], "PUT").then(function (data) {
    return store.dispatch({
      type: "UPDATE_SELECTION",
      data: data
    });
  }).catch(function (err) {
    return console.log("DEBUG: err", err);
  });
};
export var addVoucher = function addVoucher(voucherCode) {
  var token = store.getState().store.token;
  if (inputError(voucherCode)) {
    store.dispatch({
      type: "VOUCHER_ERROR"
    });
    return new Promise(function (resolve, reject) {
      return reject();
    });
  }
  return fetchCheckout("/vouchers", token, {
    voucher: voucherCode
  }, "POST").then(function (data) {
    if (data.errors) return store.dispatch({
      type: "VOUCHER_ERROR"
    });
    store.dispatch({
      type: "VOUCHER_INPUT",
      value: ""
    });
    return store.dispatch({
      type: "UPDATE_SELECTION",
      data: data
    });
  }).catch(function (err) {
    return console.log("DEBUG: err", err);
  });
};
export var removeVoucher = function removeVoucher(voucherId) {
  var token = store.getState().store.token;
  return fetchCheckout("/vouchers/".concat(voucherId), token, {}, "DELETE").then(function (data) {
    return store.dispatch({
      type: "UPDATE_SELECTION",
      data: data
    });
  }).catch(function (err) {
    return console.log("DEBUG: err", err);
  });
};
export var forceTermsAndCondition = function forceTermsAndCondition(value) {
  var termsAndConditions = store.getState().payment.termsAndConditions;
  if (termsAndConditions !== undefined && Boolean(termsAndConditions) === Boolean(value)) return;
  store.dispatch({
    type: "UPDATE_ADDRESS",
    group: "",
    id: "termsAndConditions",
    value: value
  });
};
export var changeAddressInput = function changeAddressInput(group, id, value) {
  return store.dispatch({
    type: "UPDATE_ADDRESS",
    group: group,
    id: id,
    value: value
  });
};
export var changeUseShippingInput = function changeUseShippingInput() {
  return store.dispatch({
    type: "BOOLEAN_CHANGE",
    id: "useShipping"
  });
};
export var changeGiftWrapInput = function changeGiftWrapInput(value) {
  var _store$getState$payme4 = store.getState().payment.additionalNotes,
    additionalNotes = _store$getState$payme4 === void 0 ? "" : _store$getState$payme4;
  // Need to clip out first line to ensure it remains.
  store.dispatch({
    type: "UPDATE_ADDRESS",
    group: "",
    id: "additionalNotes",
    value: "".concat(additionalNotes.match(/^(.*[\s]*)/)[0]).concat(value)
  });
};
export var changeSelectionFailedStatus = function changeSelectionFailedStatus(hasError) {
  setCookie("renderSelectionError", true);
  return store.dispatch({
    type: "SELECTION_FAILED",
    hasError: hasError
  });
};
export var initiateIngrid = function initiateIngrid() {
  var country = store.getState().store.country;
  var _store$getState9 = store.getState(),
    shipwallet = _store$getState9.shipwallet,
    countries = _store$getState9.countries;
  if (shipwallet == undefined) return;
  $("#js-shipwalletSnippet").height("");
  if (typeof countries !== "undefined" && countries[country] && countries[country].shipTo && shipwallet.sessionId && shipwallet.snippet) {
    $("#js-shipwalletSnippet").html(shipwallet.snippet);
  } else {
    $("#js-shipwalletSnippet").html("<div class=\"u-error\" style=\"color: red;\">".concat(window.sitewide.ingridError, "</div>"));
  }
};
export var resetCheckoutFields = function resetCheckoutFields(country, state) {
  var token = store.getState().store.token;
  if (!token) {
    console.log("no token in store");
    return;
  }
  var paymentData = {
    address: {
      country: country,
      state: state,
      zipCode: null
    },
    shippingAddress: {
      country: country,
      state: state,
      zipCode: null
    }
  };
  Object.keys(paymentData.address).forEach(function (id) {
    changeAddressInput("address", id, paymentData.address[id]);
  });
  Object.keys(paymentData.shippingAddress).forEach(function (id) {
    changeAddressInput("shippingAddress", id, paymentData.shippingAddress[id]);
  });
  return fetchCheckout("/payment-fields", token, paymentData, "PUT").then(function (data) {
    if (data.errors) {
      return store.dispatch({
        type: "SELECTION_ERROR",
        hasError: true
      });
    }
    return store.dispatch({
      type: "UPDATE_SELECTION",
      data: data
    });
  }).catch(function (err) {
    return console.log("DEBUG: err", err);
  });
};
export var updateIngrid = function updateIngrid(data) {
  var _store$getState$store5 = store.getState().store,
    token = _store$getState$store5.token,
    country = _store$getState$store5.country;
  var _store$getState10 = store.getState(),
    useShippingAddress = _store$getState10.useShippingAddress;
  var paymentData = {};
  if (data.additionalFields.event === "shipwallet_shipping_option_changed") {
    paymentData.additionalFields = data.additionalFields;
  }
  if (data.address) {
    paymentData.address = data.address;
  }
  if (paymentData.address) {
    Object.keys(paymentData.address).forEach(function (id) {
      if (!useShippingAddress) changeAddressInput("address", id, paymentData.address[id]);
      changeAddressInput("shippingAddress", id, paymentData.address[id]);
    });
  }
  if (paymentData.shippingAddress) {
    Object.keys(paymentData.shippingAddress).forEach(function (id) {
      changeAddressInput("shippingAddress", id, paymentData.shippingAddress[id]);
    });
  }
  if (data.address && paymentData.address) {
    paymentData.address.country = country;
  }
  return fetchCheckout("/payment-fields", token, paymentData, "PUT").then(function (data) {
    if (data.errors) {
      return store.dispatch({
        type: "SELECTION_ERROR",
        hasError: true
      });
    }
    return store.dispatch({
      type: "UPDATE_SELECTION",
      data: data
    });
  }).catch(function (err) {
    return console.log("DEBUG: err", err);
  });
};
export var initiateKlarna = function initiateKlarna() {
  var token = store.getState().store.token;
  var _store$getState11 = store.getState(),
    _store$getState11$sel = _store$getState11.selection,
    selection = _store$getState11$sel === void 0 ? {} : _store$getState11$sel;
  var hasKlarnaCheckout = paymentMethodsMap.klarnaCheckout.indexOf(selection.paymentMethod) !== -1;
  if (!hasKlarnaCheckout || !window.CentraCheckout) return new Promise(function (resolve, reject) {
    return reject();
  });
  var paymentData = {};
  paymentData.paymentFailedPage = window.sitewide.paymentFailedPage;
  paymentData.paymentReturnPage = window.sitewide.paymentReturnPage;
  return fetchCheckout("/payment", token, paymentData, "POST").then(function (data) {
    if (data.errors && data.errors.stock) {
      store.dispatch({
        type: "UPDATE_SELECTION",
        data: data
      });
      return store.dispatch({
        type: "INITIATE_SELECTION",
        data: {
          formHtml: ""
        },
        error: "SELECTION_ERROR_STOCK"
      });
    }
    if (data.errors) {
      store.dispatch({
        type: "UPDATE_SELECTION",
        data: data
      });
      return store.dispatch({
        type: "INITIATE_SELECTION",
        data: {
          formHtml: ""
        },
        error: "SELECTION_ERROR_PAYMENT"
      });
    }
    console.log(data);
    return store.dispatch({
      type: "INITIATE_SELECTION",
      data: data
    });
  }).catch(function (err) {
    return console.log("DEBUG: err", err);
  });
};
export var updateKlarna = function updateKlarna() {
  var _store$getState12 = store.getState(),
    useShippingAddress = _store$getState12.useShippingAddress,
    countries = _store$getState12.countries;
  var _store$getState$store6 = store.getState().store,
    token = _store$getState$store6.token,
    country = _store$getState$store6.country;
  var paymentData = removeInvalidPaymentFields(store.getState().payment, countries, country, useShippingAddress);
  delete paymentData.termsAndConditions;
  if (window.CentraCheckout) {
    window.CentraCheckout.suspend();
  }
  return fetchCheckout("/payment-fields", token, paymentData, "PUT").then(function (data) {
    return store.dispatch({
      type: "PAYMENT_RETURN",
      data: data
    });
  }).catch(function (err) {
    return console.log("DEBUG: err", err);
  });
};
export var checkDutyConsent = function checkDutyConsent() {
  var totals = store.getState().selection.totals;
  var country = store.getState().store.country;
  var dutyConsent = window.sitewide.dutyconsent;
  var duty = dutyConsent.country[country];
  var grandtotal = totals ? totals.grandTotalPriceAsNumber : 0;
  return duty !== undefined && (duty.required || false) && grandtotal >= parseFloat(duty.price_limit);
};
var adyenEvaluate = function adyenEvaluate(subtree) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  function getSnippetType(script) {
    return script.type || "";
  }
  function getRawSnippet(script) {
    return script.text || script.textContent || script.innerHTML || "";
  }
  if (subtree) {
    try {
      var scripts = subtree.getElementsByTagName("script");
      var scriptsAsArray = Array.from(scripts).filter(function (script) {
        return getSnippetType(script) !== "application/json";
      });
      scriptsAsArray.forEach(function (script) {
        var unescaped = getRawSnippet(script).replace(/\\/gi, "");
        eval.call(context, unescaped); // eslint-disable-line no-eval
      });
    } catch (error) {
      console.error("Catched error in evaluate function:", error);
    }
  }
};
var paymentSelected = function paymentSelected(event) {
  var _store$getState13 = store.getState(),
    useShippingAddress = _store$getState13.useShippingAddress,
    countries = _store$getState13.countries;
  var _store$getState$store7 = store.getState().store,
    token = _store$getState$store7.token,
    country = _store$getState$store7.country;
  var _event$detail = event.detail,
    paymentMethodSpecificFields = _event$detail.paymentMethodSpecificFields,
    paymentMethod = _event$detail.paymentMethod,
    responseEventRequired = _event$detail.responseEventRequired;
  var storeFields = removeInvalidPaymentFields(store.getState().payment, countries, country, useShippingAddress);
  var paymentData = _objectSpread({
    paymentMethod: paymentMethod,
    paymentMethodSpecificFields: paymentMethodSpecificFields
  }, storeFields);
  return fetchCheckout("/payment", token, paymentData, "POST").then(function (response) {
    if (responseEventRequired) {
      if (response.action === "redirect") {
        window.location.href = response.url;
        return;
      }
      if (response.action === "success") {
        window.location.href = window.sitewide.paymentReturnPage;
        return;
      }
      if (response.errors) {
        // Payment failed for some reason, show error
        store.dispatch({
          type: "SELECTION_ERROR",
          hasError: true
        });
      }
      // action is javascript
      if (response.formFields) {
        var returnObject = response.formFields;
        var updateEvent = new CustomEvent("centra_checkout_payment_response", {
          detail: returnObject
        });
        document.dispatchEvent(updateEvent);
      } else {
        store.dispatch({
          type: "SELECTION_ERROR",
          hasError: true
        });
      }
    }
  }).catch(function (err) {
    return console.log(err);
  });
};
export var purchase = function purchase(enableScroll) {
  var _store$getState14 = store.getState(),
    useShippingAddress = _store$getState14.useShippingAddress,
    countries = _store$getState14.countries;
  var paymentFields = store.getState().selection.paymentFields;
  var _store$getState$store8 = store.getState().store,
    token = _store$getState$store8.token,
    country = _store$getState$store8.country;
  var paymentData = deepClone(store.getState().payment);
  var hasErrors = false;
  var keepPassword = false;
  // Dummy function to enable thens if no sign in required.
  var createAccountFirst = function createAccountFirst() {
    return new Promise(function (resolve) {
      return resolve();
    });
  };

  // Remove account information if not creating an account.
  if (!paymentData.createAccount) {
    delete paymentData.address.password;
    store.dispatch({
      type: "UPDATE_ERRORS",
      group: "address",
      id: "password",
      error: false
    });
    store.dispatch({
      type: "UPDATE_ERRORS",
      group: "address",
      id: "passwordRepeat",
      error: false
    });
  } else {
    // Create account
    if (inputError(paymentData.address.password, "password")) {
      hasErrors = true;
      store.dispatch({
        type: "UPDATE_ERRORS",
        group: "address",
        id: "password",
        error: true
      });
    }
    if (paymentData.address.password !== paymentData.address.passwordRepeat) {
      hasErrors = true;
      store.dispatch({
        type: "UPDATE_ERRORS",
        group: "address",
        id: "passwordRepeat",
        error: true
      });
    }
    keepPassword = true;
    createAccountFirst = function createAccountFirst() {
      return register(token, paymentData.address);
    };
  }
  if (checkDutyConsent() && paymentData.dutyConsent !== "true") {
    hasErrors = true;
    store.dispatch({
      type: "SELECTION_ERROR_DUTY_CONSENT",
      hasError: true
    });
  }
  paymentData = removeInvalidPaymentFields(paymentData, countries, country, useShippingAddress, keepPassword);

  // Check for errors.
  Object.keys(paymentFields).forEach(function (firstLevel) {
    if (firstLevel === "address" || firstLevel === "shippingAddress" && useShippingAddress) {
      Object.keys(paymentFields[firstLevel]).forEach(function (secondLevel) {
        var field = firstLevel === "shippingAddress" ? paymentFields.address[secondLevel] : paymentFields[firstLevel][secondLevel];

        // We've already evaluated these.
        if (secondLevel === "password" || secondLevel === "passwordRepeat") return;
        if (field.visible && field.required) {
          // We should have a value. Is it correct?
          var fieldType = secondLevel === "email" ? "email" : "text";
          var fieldValue = paymentData[firstLevel][secondLevel];
          if (secondLevel === "phoneNumber") {
            fieldType = "phoneNumber";
          } else if (secondLevel === "zipCode") {
            fieldType = "zipCode";
            fieldValue = {
              country: country,
              zipCode: paymentData[firstLevel][secondLevel]
            };
          } else if (/address/i.test(secondLevel)) {
            fieldType = "address";
          }
          var error = inputError(fieldValue, fieldType);
          if (error) {
            store.dispatch({
              type: "UPDATE_ERRORS",
              group: firstLevel,
              id: secondLevel,
              error: error
            });

            // Set address counterpart as error too if not using shipping address
            if (firstLevel === "address" && !useShippingAddress) {
              store.dispatch({
                type: "UPDATE_ERRORS",
                group: "shippingAddress",
                id: secondLevel,
                error: error
              });
            }
            hasErrors = true;
          }
        }
      });
    } else if (firstLevel !== "shippingAddress") {
      var field = paymentFields[firstLevel];
      if (field.visible && field.required) {
        // We should have a value. Is it correct?
        var error = inputError(paymentData[firstLevel], "text");
        if (error) {
          store.dispatch({
            type: "UPDATE_ERRORS",
            id: firstLevel,
            error: error
          });
          hasErrors = true;
        }
      }
    }
  });
  if (paymentData.address.country && countries[paymentData.address.country] && !countries[paymentData.address.country].shipTo) {
    // Country shipto is not enabled
    hasErrors = true;
    store.dispatch({
      type: "UPDATE_ERRORS",
      group: "address",
      id: "country",
      error: true
    });
  }
  if (!paymentData.address.state && countries[paymentData.address.country] && countries[paymentData.address.country].states) {
    // Missing state
    hasErrors = true;
    var group = useShippingAddress ? "address" : "shippingAddress";
    store.dispatch({
      type: "UPDATE_ERRORS",
      group: group,
      id: "state",
      error: true
    });
  }
  if (useShippingAddress && !paymentData.shippingAddress.state && countries[paymentData.shippingAddress.country] && countries[paymentData.shippingAddress.country].states) {
    // Missing shipping state
    hasErrors = true;
    store.dispatch({
      type: "UPDATE_ERRORS",
      group: "shippingAddress",
      id: "state",
      error: true
    });
  }
  if (hasErrors) {
    $("#checkout-adyen").hide();

    // Scroll to error
    var visibleError = $(".has-error:visible,.is-invalid:visible");
    if (visibleError.length > 0 && !stokpress.isInView(visibleError.first()[0], "completely")) {
      scrollToElement(visibleError.first().parent(), 20);
    }
    return store.dispatch({
      type: "SELECTION_ERROR",
      hasError: true
    });
  }
  if (!useShippingAddress) {
    paymentData = Object.keys(paymentData).filter(function (data) {
      return data !== "shippingAddress";
    }).reduce(function (acc, data) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, data, paymentData[data]));
    }, {});
  }
  if (typeof window.dataLayer === "undefined") window.dataLayer = [];
  window.dataLayer.push({
    event: "SubmitCheckout",
    values: _objectSpread({}, paymentFields.address)
  });
  $("#js-purchase").addClass("is-loading");
  $("#js-adyenDropIn").html("");
  return createAccountFirst().then(function (data) {
    if (data && data.type && (data.type === "ACCOUNT_ENTRY_FAILED" || data.type === "SELECTION_ERROR_REGISTERED")) return Promise.reject(new Error("Register failed"));
    return fetchCheckout("/payment", token, paymentData, "POST");
  }).then(function (data) {
    $("#js-purchase").parent().hide();
    $("#js-purchase").removeClass("is-loading");
    if (data.action === "redirect") {
      // Redirect to new URL
      window.location = data.url;
      return false;
    }
    if (data.action === "form") {
      // Return to checkout to display form

      if (data.formType === "adyen-checkout") {
        var $checkoutContainer = document.getElementById("adyenCheckoutContainer");
        $checkoutContainer.innerHTML = data.formHtml;
        adyenEvaluate($checkoutContainer);
        store.dispatch({
          type: "ADYEN_INITIATED"
        });
        store.dispatch({
          type: "ADYEN_UPDATING",
          isUpdating: false
        });
        return false;
      }
      if (data.formType === "adyen-drop-in") {
        $("#js-adyenDropIn").html(data.formHtml);
        $("#checkout-adyen").show();
        store.dispatch({
          type: "ADYEN_INITIATED"
        });
        store.dispatch({
          type: "ADYEN_UPDATING",
          isUpdating: false
        });
        if (enableScroll) {
          scrollToElement($("#checkout-adyen").first(), 20);
          // $( "html,body" ).stop( true ).animate( {
          // 	scrollTop: $( '#checkout-adyen' ).last().offset().top - ( window.innerHeight / 4 )
          // }, 500 );
        }
        document.addEventListener("centra_checkout_payment_callback", paymentSelected);
        return false;
      }
      var d = document.createElement("div");
      d.innerHTML = data.formHtml;
      document.body.appendChild(d);
      d.querySelector("form").submit();
      return false;
    }
    if (data.action === "success") {
      // Purchase complete navigate to receipt.
      window.location = window.sitewide.paymentReturnPage;
      return true;
    }
    if (data.errors && data.errors.stock) {
      store.dispatch({
        type: "UPDATE_SELECTION",
        data: data
      });
      store.dispatch({
        type: "ADYEN_UPDATING",
        isUpdating: false
      });
      return store.dispatch({
        type: "SELECTION_ERROR_STOCK",
        hasError: true
      });
    }
    if (data.errors && data.errors.registered) {
      return store.dispatch({
        type: "SELECTION_ERROR_REGISTERED",
        hasError: true
      });
    }
    return store.dispatch({
      type: "SELECTION_ERROR_PAYMENT",
      hasError: true
    });
  }).catch(function (err) {
    console.log("DEBUG: err", err);
    $("#js-purchase").parent().show();
    $("#js-purchase").removeClass("is-loading");
  });
};
export var updateAdyen = function updateAdyen() {
  var _store$getState15 = store.getState(),
    _store$getState15$ady = _store$getState15.adyenInitiated,
    adyenInitiated = _store$getState15$ady === void 0 ? false : _store$getState15$ady;
  var _store$getState16 = store.getState(),
    _store$getState16$sel = _store$getState16.selection,
    selection = _store$getState16$sel === void 0 ? {} : _store$getState16$sel;
  var hasAdyen = paymentMethodsMap.adyenDropIn.indexOf(selection.paymentMethod) !== -1;
  if (adyenInitiated && hasAdyen) {
    store.dispatch({
      type: "ADYEN_UPDATING",
      isUpdating: true
    });

    // Hide Adyen and show payment button again.
    return purchase(false);
  }
  return new Promise(function (resolve) {
    return resolve();
  });
};
export var paymentResult = function paymentResult() {
  var token = store.getState().store.token;
  if (token) {
    return fetchCheckout("/payment-result", token, {
      paymentMethodFields: window.tokens
    }, "POST").then(function (selectionData) {
      if (selectionData.token && selectionData.order && !selectionData.errors) {
        return store.dispatch({
          type: "RECEIPT_DATA",
          data: selectionData
        });
      }
      var selectionFailedData = changeSelectionFailedStatus(true);
      window.location = window.sitewide.paymentFailedPage;
      return selectionFailedData;
    }).catch(function (err) {
      console.error(err);
      changeSelectionFailedStatus(true);
    });
  }
  console.log("No token");
  return changeSelectionFailedStatus(true);
};
export var destroySelection = function destroySelection() {
  var _store$getState17 = store.getState(),
    countries = _store$getState17.countries;
  var country = store.getState().store.country;
  var defaultCountrySettings = countries[country];
  // Clear possible campaign market/pricelist to keep in sync with Centra.
  store.dispatch({
    type: "UPDATE_COUNTRY",
    country: country,
    market: parseInt(defaultCountrySettings.market, 10),
    pricelist: parseInt(defaultCountrySettings.pricelist, 10)
  });
  if (window.sitewide.paymentReturnPage === "".concat(window.location.origin).concat(window.location.pathname)) {
    store.dispatch({
      type: "SET_DEFAULT_PAYMENT_METHOD",
      status: false
    });
  }
  store.dispatch({
    type: "DESTROY_SELECTION"
  });
};

/**
 * @constructor
 * @param {string} item - Size item of bundle
 * @param {array} sections - Section id and bundle product item pairs
 */
export var addBundleToBag = function addBundleToBag(item, sections) {
  var _store$getState$store9 = store.getState().store,
    token = _store$getState$store9.token,
    country = _store$getState$store9.country;
  var _store$getState18 = store.getState(),
    selection = _store$getState18.selection;

  // Check if there's no selection exists
  if (!country) {
    setCountry();
  } else if (Object.keys(selection).length === 0 || !token) {
    updateSelection(token || "");
  }
  return fetchCheckout("/items/bundles/".concat(item), token, {
    item: item,
    sections: sections
  }, "POST").then(function (data) {
    if (data.errors) return store.dispatch({
      type: "ADD_TO_BAG_ERROR"
    });
    return store.dispatch({
      type: "UPDATE_SELECTION",
      data: data
    });
  }).catch(function (err) {
    return console.log("DEBUG: err", err);
  });
};


// WEBPACK FOOTER //
// ./scripts/shop/connect.js